<p class="sp-mb-24" *ngIf="isInvokerTypeOKR">
  {{ "clone_move_okr_confirmation_message" | localize }}
</p>

<p class="sp-mb-24" *ngIf="!isInvokerTypeOKR">
  {{ "clone_move_kr_confirmation_message" | localize }}
</p>
